import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import i18n from './i18n'
import {
	Timeline
} from 'vue-visjs-timeline';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import './assets/iconfont/iconfont.css'
import './utils/lazyLoad'

// 全局注册 Timeline 组件
Vue.component('Timeline', Timeline);
Vue.use(ElementUI)
new Vue({
	render: h => h(App),
	router,
	i18n
}).$mount('#app')